import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {RouteId} from 'src/app/enums/env/routes-id-enum';
import {RouteIndicatorResponse} from 'src/app/shared/types/routes/indicator-route.types';
import {
  StationConnectivityCountRepo
} from 'src/app/repositories/station/repo/station-connectivity-count-repo';

export const connectivityTabIndicatorResolver: ResolveFn<RouteIndicatorResponse> = () => {
  const stationConnectivityCountRepo = inject(StationConnectivityCountRepo);

  return {
    [RouteId.DASHBOARD_CONNECTIONS]: stationConnectivityCountRepo.disconnectedStationsCount$,
  }
};
